module.exports = __webpack_public_path__ + "img/eye.6430aaed.svg";